import { Box, FormLabel, Grid, TextField, Typography } from '@mui/material';
import { useActividadesContext } from '../../UmmIACategories/Hook/useActividades';

const SituacionSignificativa = () => {
    const { promptData, setPromptData } = useActividadesContext();


    const handleSituacionSignificativa = (event) => {
        const situacion_significativa = event.target.value;

        setPromptData((prevData) => ({
            ...prevData,
            situacion_significativa: situacion_significativa
        }));
    };

    return (
        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            <Box>
                <Box sx={{ display: 'flex', flexDirection: 'column', }}>
                    <Typography sx={{ fontFamily: 'montserrat', fontSize: '1.25rem', fontWeight: 'bold', color: '#336B87' }}>
                        Situación significativa
                    </Typography>
                    <FormLabel sx={{ fontFamily: 'montserrat', fontSize: '0.85rem' }}>Describe la situación significativa</FormLabel>
                </Box>
                <TextField
                    fullWidth
                    variant="outlined"
                    value={promptData.situacion_significativa}
                    onChange={handleSituacionSignificativa}
                    InputProps={{
                        sx: {
                            mt: 1,
                            mb: 3,
                            fontFamily: 'montserrat',
                            fontSize: '0.75rem',
                            color: '#005559',
                            '&::placeholder': {
                                color: '#005559',

                            },
                            '&:before': {
                                borderBottomColor: '#005559',

                            },
                            '&:after': {
                                borderBottomColor: '#005559',
                            },
                        }
                    }}
                />
            </Box>
        </Grid>
    );
};

export default SituacionSignificativa;
